export default "__VITE_ASSET__d8784072__"